import React from 'react';
import './LoaderSmall.css';

const LoaderSmall = () => {
    return (
        <div className='flex justify-center items-center '>
            <span class="loader"></span>
        </div>
    );
};

export default LoaderSmall;